import { useEffect } from 'react';

export const useScrollOnExpand = (isCollapsed, ref) => {
  useEffect(() => {
    if (!isCollapsed) {
      const timer = setTimeout(() => {
        if (ref.current) {
          const elementBottom = ref.current.getBoundingClientRect().bottom;
          const offset = 80; // Extra space for the footer toolbar
          const top = window.scrollY + elementBottom + offset - window.innerHeight;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isCollapsed, ref]);
};
